module.exports = __webpack_public_path__ + "media/images/questionnaire_overview/proof-read-890fdd0e2f60701741082b777930a265.svg";